/** First calendar date at least 6 months after fromDate (YYYY-MM-DD). Timezone-safe. */
export function getMinToDateAfterSixMonths(fromDate: string): string {
  const [y, m, day] = fromDate.split('-').map(Number);
  const d = new Date(Date.UTC(y, m - 1, day, 12, 0, 0));
  d.setUTCMonth(d.getUTCMonth() + 6);
  return d.toISOString().split('T')[0];
}
